import { createFileRoute } from "@tanstack/react-router";
import { ExamLanding } from "@/components/marketing/exam-landing";
import { getExam } from "@/lib/exams";
import { breadcrumbScript, seo } from "@/lib/seo";

const SLUG = "neet";

export const Route = createFileRoute("/neet")({
  head: () => {
    const exam = getExam(SLUG);
    const base = seo({ title: exam.title, description: exam.description, path: `/${SLUG}` });
    return {
      ...base,
      scripts: [
        breadcrumbScript([
          { name: "Home", path: "/" },
          { name: exam.name, path: `/${SLUG}` },
        ]),
      ],
    };
  },
  component: ExamPage,
});

function ExamPage() {
  return <ExamLanding exam={getExam(SLUG)} />;
}
